export default "__VITE_ASSET__DyvJ5oqC__"